import React from 'react';
import Collage_Subject from './Collage_Subject';
import '../../../CommonCSS/SocietyCSS.css'

const Collage_SubjectApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> College Subjects</h5>
          </div>  
        </div>
        <Collage_Subject/>
      </div>
    </div >
  );
};

export default Collage_SubjectApp;
